<template>
  <router-view />
</template>

<style>
/* 样式可根据需求调整 */
header {
  padding: 10px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #ddd;
}
nav a {
  margin-right: 15px;
  text-decoration: none;
  color: #007bff;
}
nav a:hover {
  text-decoration: underline;
}
</style>
